import { Theme } from '@mui/material';
import { globalClasses } from 'core/common/constants/global-classes';

type ProgressBarComponentType = {
  styleOverrides: {
    root: () => Record<string, unknown>;
  };
};

export const getProgressBarOptions = ({
  palette,
}: Theme): { progressBarComponent: ProgressBarComponentType } => {
  const progressBarComponent = {
    styleOverrides: {
      root: () => {
        return {
          flex: 1,
          height: '6px',
          borderRadius: '30px',
          backgroundColor: palette.progressBar.main,

          [`& ${globalClasses.MuiLinearProgressBar}`]: {
            backgroundColor: palette.progressBar.mainFilled,
            borderRadius: '30px',
            transition: 'transform 0.4s linear',
          },
        };
      },
    },
  };

  return { progressBarComponent };
};
